import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Statistics from './Statistics';
import authHelper from 'helpers/auth';
import config from 'helpers/config';
import { fetchDashboardStats } from 'store/actions/dashboardActions';
import moment from 'moment';

class Dashboard extends React.Component {
    constructor(props) {
        super(props);

        const { daysInBetween } = props;

        const today = moment().format('YYYY-MM-DD');
        const todayMinusDifference = moment().subtract(daysInBetween, 'days')
            .format('YYYY-MM-DD');
        const lastYear = moment().subtract(1, 'year')
            .format('YYYY-MM-DD');
        const lastYearMinusDifference = moment().subtract(1, 'year')
            .subtract(daysInBetween, 'days')
            .format('YYYY-MM-DD');

        this.state = {
            isLoading: true,
            today: today,
            todayMinusDifference: todayMinusDifference,
            lastYear: lastYear,
            lastYearMinusDifference: lastYearMinusDifference,
        };
    }

    /**
     * After mounting of the component.
     */
    componentDidMount() {
        this.fetchStatistics();
    }

    /**
     * Fetching the statistics by builing two different dateranges.
     */
    fetchStatistics = () => {
        const { fetchDashboardStats } = this.props;

        const {
            todayMinusDifference,
            today,
            lastYearMinusDifference,
            lastYear,
        } = this.state;

        const isProvider = authHelper.isProvider();

        // Default url
        const url = isProvider ? `${ config.getApiBaseUrl() }/reservations/statistics` : `${ config.getApiBaseUrl() }/statistics/bookings`;

        const baseParams = {
            base: 'created_at',
            filters: {
                reservation_status: [
                    'completed',
                ],
                is_test_order: 0,
            },
            interval: 'day',
            size: 48,
            sort_by: 'id',
            sort_direction: 'desc',
        };

        /**
         * We calculate from the current day.
         * from: The current day minus the amount of daysInBetween (28).
         * to: current day.
         */
        const firstDateRangeParams = {
            ...baseParams,
            from: todayMinusDifference,
            to: today,
        };

        /**
         * We calculate a year from the current day.
         * from: last year minus the amount of daysInBetween (28).
         * to: last year, current day.
         */
        const secondDateRangeParams = {
            ...baseParams,
            from: lastYearMinusDifference,
            to: lastYear,
        };

        fetchDashboardStats({
            callback: () => {
                this.setState({
                    isLoading: false,
                });
            },
            queries: [
                firstDateRangeParams,
                secondDateRangeParams,
            ],
            url: url,
        });
    }

    render() {
        const { daysInBetween, data, reference } = this.props;
        const { isLoading, lastYear, today } = this.state;

        const { currency: { system } } = this.context.config;

        if (isLoading) {
            return null;
        }

        return (
            <Statistics
                data={ data }
                daysInBetween={ daysInBetween }
                today={ today }
                lastYear={ lastYear }
                reference={ reference }
                system={ system }
            />
        );
    }
}

Dashboard.contextTypes = {
    config: PropTypes.object,
};

Dashboard.propTypes = {
    data: PropTypes.array,
    daysInBetween: PropTypes.number,
    fetchDashboardStats: PropTypes.func.isRequired,
    reference: PropTypes.string.isRequired,
};

Dashboard.defaultProps = {
    data: [],
    daysInBetween: 28,
};

const mapStateToProps = (state) => {
    const isProvider = authHelper.isProvider();

    return {
        data: state.dashboard.data,
        reference: isProvider ? 'reservations' : 'bookings',
    };
};

const mapDispatchToProps = {
    fetchDashboardStats: fetchDashboardStats,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js